import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { Pair } from '../../../interfaces/pair';
import { PairService } from '../../../services/pair.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-unpair-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  templateUrl: './unpair-dialog.component.html',
  styleUrl: './unpair-dialog.component.scss'
})
export class UnpairDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<UnpairDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { pair: Pair },
    private pairService: PairService,
    private snackBar: MatSnackBar
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onUnpair(): void {
    const reasonRemoval = 'Unpaired by user';

    this.pairService.unpairPair(this.data.pair.id!, reasonRemoval).subscribe({
      next: (response) => {
        console.log('Pair unpaired:', response);
        this.showNotification('Pair unpaired successfully! Donor is now a solo donor.');
        this.dialogRef.close({ action: 'unpair', pairId: this.data.pair.id });
      },
      error: (err) => {
        console.error('Error unpairing pair:', err);
        this.showNotification('Failed to unpair. Please try again.');
      }
    });
  }

  private showNotification(message: string, action: string = 'Close'): void {
    this.snackBar.open(message, action, {
      duration: 3000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }
}
